import api from './api';

export const meApi = {
  // 내 리뷰 목록 조회
  getMyReviews: async () => {
    const response = await api.getAuth('/me/reviews');
    return response.data;
  },

  // 내 플레이리스트 목록 조회
  getMyLists: async () => {
    const response = await api.getAuth('/me/lists');
    return response.data;
  },

  // 내 댓글 목록 조회
  getMyComments: async () => {
    const response = await api.getAuth('/me/comments');
    return response.data;
  },

  // 내 북마크 목록 조회
  getMyBookmarks: async () => {
    const response = await api.getAuth('/me/saved');
    return response.data;
  },

  // 내 프로필 수정
  updateProfile: async (data) => {
    const response = await api.putAuth('/me', data);
    return response.data;
  },

  // 회원 탈퇴
  withdraw: async () => {
    const response = await api.putAuth('/me/withdraw');
    return response.data;
  },
};
